// 根级别的 mutation

import * as types from './mutations-type.js'

const mutations = {
  [types.SET_MENU_ARR] (state, menuArr) {
    state.menuArr = menuArr
  },
  [types.SET_CURRENT_MENU] (state, menu) {
    state.currentMenu = menu
  },
  [types.SET_CURRENT_POSITION] (state, position) {
    state.currentPosition = position
  },
  [types.SET_QUERY_CONDITION] (state, condition) {
    state.queryCondition = condition
  },
  [types.SET_CONDITION_DESC] (state, desc) {
    state.conditionDesc = desc
  },
  [types.SET_MKEY_DESCRIPTION] (state, description) {
    state.mkeyDescription = description
  },
  [types.SET_REPORT_BASEURL] (state, url) {
    state.reportBaseUrl = url
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js